<div
  class="mx-auto flex w-full max-w-[440px] flex-col items-center text-center text-black dark:text-white"
>
  @if (!news.media) {
  <img
    src="/assets/icons/gemster-icon-192.png"
    alt="Gemster"
    class="mb-3.5 size-15 rounded-[24%]"
  />
  }
  <h2 class="!m-0 font-base text-lg font-bold break-words w-full">
    {{ text.title }}
  </h2>
  <p
    class="mt-2 w-full whitespace-pre-wrap break-words text-base leading-relaxed text-black/80 dark:text-white/80"
  >
    {{ text.content }}
  </p>
  @if (news.media) {
  <figure class="mt-3 w-full">
    @if (!mediaError) { @if (news.media.type === 'image') {
    <img
      [src]="mediaUrl"
      [alt]="text.mediaAlt || ''"
      (error)="mediaFailed()"
      (load)="mediaLoadFailed.emit(false)"
      class="mx-auto max-h-[35dvh] w-full rounded-lg object-contain"
    />
    } @else {
    <video
      #video
      [src]="mediaUrl"
      controls
      playsinline
      [muted]="true"
      preload="metadata"
      [attr.aria-label]="text.mediaAlt || text.title"
      (error)="mediaFailed()"
      (loadedmetadata)="videoLoaded(video)"
      class="mx-auto max-h-[35dvh] w-full rounded-lg object-contain"
    ></video>
    } } @if (mediaError) {
    <p role="status" class="text-sm text-grey dark:text-lightGrey">
      {{ "APP_NEWS_MEDIA_LOAD_FAILED" | translate }}
    </p>
    } @if (news.media.type === 'video' && text.mediaAlt) {
    <figcaption class="mt-1 text-sm text-grey dark:text-lightGrey">
      {{ text.mediaAlt }}
    </figcaption>
    }
  </figure>
  } @if (news.ctaUrl && text.ctaLabel) { @if (news.ctaUrl.startsWith('/')) {
  <a
    [routerLink]="internalLink"
    class="btn btn-primary mt-4.5 w-full no-underline"
    (click)="dismissed.emit()"
    >{{ text.ctaLabel }}</a
  >
  } @else {
  <a
    [attr.href]="preview ? null : news.ctaUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="btn btn-primary mt-4.5 w-full no-underline"
    (click)="dismissed.emit()"
    >{{ text.ctaLabel }}</a
  >
  } }
  <button
    type="button"
    class="mt-2 min-h-[44px] px-2 text-base underline underline-offset-4"
    (click)="dismissed.emit()"
  >
    {{ "CLOSE" | translate }}
  </button>
</div>
